/*
  Resolves ADLS filesystem + blob path for preview/download API calls.

  Active container comes from REACT_APP_ADLS_SEARCH_FILESYSTEM.
  Strips a redundant "<filesystem>/" prefix from DB storage paths.
  Legacy ingest prefixes are resolved on the backend via blob-exists retry.
*/

function normalizeSlashes(rawPath) {
  return String(rawPath || "")
    .trim()
    .replace(/^\/+/, "")
    .replace(/\\/g, "/");
}

export function stripContainerPrefix(filesystem, rawPath) {
  if (!rawPath) {
    return "";
  }

  let normalized = normalizeSlashes(rawPath);

  if (!filesystem) {
    return normalized;
  }

  const prefix = `${filesystem}/`;

  if (normalized.toLowerCase().startsWith(prefix.toLowerCase())) {
    normalized = normalized.slice(prefix.length);
  }

  return normalized;
}

export function resolveAdlsPath(rawPath, defaultFilesystem) {
  const cleaned = normalizeSlashes(rawPath);

  if (!cleaned) {
    throw new Error("Invalid file path");
  }

  if (!defaultFilesystem) {
    throw new Error("ADLS filesystem not configured");
  }

  return {
    filesystem: defaultFilesystem,
    path: stripContainerPrefix(defaultFilesystem, cleaned),
  };
}
